import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import _isNull from "lodash/isNull";
import _isFunction from "lodash/isFunction";
import "regenerator-runtime/runtime.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";

/* eslint-disable no-return-assign */

/* eslint-disable dot-notation */
import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SignatureCanvas from 'react-signature-canvas';
import { useHistory } from 'react-router-dom';
import { Paper, Row, Col, Button, FileInput, showError, showSuccess, useUser } from 'components';
import { showApiError } from 'utils';
import { getDocumentForCredit, signDocumentForCredit, getDocumentTypesForCredit, getSignTypesAfterApproval } from 'services';
import { creditDocumentsTypeName, CREDITS_SIGN_BY_TYPE, creditSignByTypeName, CREDIT_STATUS, CREDIT_PAYMENT_TYPE, CREDITS_DOCUMENTS_TYPE } from 'enums';
import { pdfWrap, signWrap, signLabel } from './styles';
import HomeVisitFeePaymentPlan from '../HomeVisitFeePaymentPlan';
import { jsx as ___EmotionJSX } from "@emotion/react";
var signByBorrower = CREDITS_SIGN_BY_TYPE.signByBorrower,
    signByEmployee = CREDITS_SIGN_BY_TYPE.signByEmployee,
    signByGuarantor = CREDITS_SIGN_BY_TYPE.signByGuarantor;
var approved = CREDIT_STATUS.approved;

var infoCard = function infoCard(theme) {
  return {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '1.2em',
    padding: '1.5em 2em',
    margin: '1em 0 1.5em',
    backgroundColor: theme.primaryLight || '#f0f7ff',
    border: "1px solid ".concat(theme.primaryFade || theme.gray200),
    borderRadius: 8
  };
};

var infoCardIcon = function infoCardIcon(theme) {
  return {
    fontSize: '2.4rem',
    color: theme.primary,
    lineHeight: 1,
    flexShrink: 0,
    marginTop: '0.1em'
  };
};

var infoCardText = function infoCardText(theme) {
  return {
    '& h4': {
      fontSize: '1.3rem',
      fontWeight: 600,
      color: theme.gray800,
      marginBottom: '0.4em'
    },
    '& p': {
      fontSize: '1.15rem',
      color: theme.gray600,
      lineHeight: 1.5,
      marginBottom: '0.3em'
    }
  };
};

var uploadSection = {
  marginBottom: '1.5em'
};

var uploadHeader = function uploadHeader(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5em',
    fontSize: '1.25rem',
    fontWeight: 600,
    color: theme.gray700,
    marginBottom: '1em',
    '& i': {
      fontSize: '1.4rem',
      color: theme.primary
    }
  };
};

var uploadDropZone = function uploadDropZone(theme) {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '2em',
    border: "2px dashed ".concat(theme.gray200),
    borderRadius: 8,
    backgroundColor: theme.gray50 || '#fafafa',
    transition: 'border-color 0.2s, background-color 0.2s',
    '&:hover': {
      borderColor: theme.primary,
      backgroundColor: theme.primaryLight || '#f0f7ff'
    }
  };
};

var uploadIcon = function uploadIcon(theme) {
  return {
    fontSize: '3rem',
    color: theme.gray300,
    marginBottom: '0.6em',
    lineHeight: 1
  };
};

var uploadMainText = function uploadMainText(theme) {
  return {
    fontSize: '1.15rem',
    color: theme.gray600,
    marginBottom: '1em',
    textAlign: 'center'
  };
};

var uploadSubText = function uploadSubText(theme) {
  return {
    fontSize: '1rem',
    color: theme.gray400,
    marginTop: '0.8em',
    fontWeight: 500
  };
};

var uploadFileInfo = function uploadFileInfo(theme) {
  return {
    fontSize: '0.95rem',
    color: theme.gray300,
    marginTop: '0.2em'
  };
};

var unsignedType = function unsignedType(documentTypes) {
  if (!documentTypes) return;
  var documentTypeName = Object.keys(documentTypes).find(function (key) {
    var value = documentTypes[key];
    return Object.values(value).some(function (v) {
      return v === false;
    });
  });
  return documentTypeName ? {
    type: documentTypeName,
    documents: documentTypes[documentTypeName]
  } : null;
};

var SignDocument = function SignDocument(_ref) {
  var _userInfo$partners, _Object$values, _credit$home_visit_fe, _creditDocumentsTypeN, _currentUnsigned$docu, _currentUnsigned$docu2, _currentUnsigned$docu3, _currentUnsigned$docu4;

  var creditId = _ref.creditId,
      creditStatus = _ref.creditStatus,
      credit = _ref.credit,
      onNext = _ref.onNext,
      isAfterApproval = _ref.isAfterApproval,
      onNoDocuments = _ref.onNoDocuments;
  var history = useHistory();

  var _useUser = useUser(),
      userInfo = _useUser.userInfo;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      pdf = _useState2[0],
      setPdf = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      documentTypes = _useState4[0],
      setDocumentTypes = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showPaymentPlanPreview = _useState6[0],
      setShowPaymentPlanPreview = _useState6[1];

  var isUserPartnerForCredit = userInfo === null || userInfo === void 0 ? void 0 : (_userInfo$partners = userInfo.partners) === null || _userInfo$partners === void 0 ? void 0 : _userInfo$partners.some(function (p) {
    return p.id === (credit === null || credit === void 0 ? void 0 : credit.partner_id);
  });
  var borrowerSignRef = useRef();
  var employeeSignRef = useRef();
  var guarantorSignRef = useRef();
  var signManualRef = useRef();
  var isSign = pdf === null || pdf === void 0 ? void 0 : pdf.isSign;
  var currentUnsigned = unsignedType(documentTypes);
  var allDocumentsSign = documentTypes && (Object === null || Object === void 0 ? void 0 : (_Object$values = Object.values(documentTypes)) === null || _Object$values === void 0 ? void 0 : _Object$values.every(function (el) {
    return (el === null || el === void 0 ? void 0 : el.signManual) === true;
  }));
  var activationFail = isAfterApproval && creditStatus === approved && allDocumentsSign;
  var shouldShowPaymentPlanPreview = (currentUnsigned === null || currentUnsigned === void 0 ? void 0 : currentUnsigned.type) === CREDITS_DOCUMENTS_TYPE.partner_documents && (credit === null || credit === void 0 ? void 0 : credit.credit_payment_type) === CREDIT_PAYMENT_TYPE.home_visit_fee_separate_payment && (credit === null || credit === void 0 ? void 0 : (_credit$home_visit_fe = credit.home_visit_fee_payment_plan) === null || _credit$home_visit_fe === void 0 ? void 0 : _credit$home_visit_fe.length) > 0;
  useEffect(function () {
    fetchDocumentTypes();
  }, []);

  var fetchDocumentTypes = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var method, _yield$method, _yield$method2, res, err, filteredRes;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              method = isAfterApproval ? getSignTypesAfterApproval : getDocumentTypesForCredit;
              _context.next = 3;
              return method(creditId);

            case 3:
              _yield$method = _context.sent;
              _yield$method2 = _slicedToArray(_yield$method, 2);
              res = _yield$method2[0];
              err = _yield$method2[1];

              if (!err) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 9:
              // Filter out partner_documents if user is not a partner for this credit
              filteredRes = _objectSpread({}, res);
              setDocumentTypes(filteredRes);
              fetchDocument(unsignedType(filteredRes));

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchDocumentTypes() {
      return _ref2.apply(this, arguments);
    };
  }();

  var fetchDocument = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(params) {
      var _yield$getDocumentFor, _yield$getDocumentFor2, res, err, url;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!isUserPartnerForCredit && (params === null || params === void 0 ? void 0 : params.type) === CREDITS_DOCUMENTS_TYPE.partner_documents)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              if (params) {
                _context2.next = 4;
                break;
              }

              return _context2.abrupt("return", _isFunction(onNoDocuments) && onNoDocuments());

            case 4:
              _context2.next = 6;
              return getDocumentForCredit(creditId, params);

            case 6:
              _yield$getDocumentFor = _context2.sent;
              _yield$getDocumentFor2 = _slicedToArray(_yield$getDocumentFor, 2);
              res = _yield$getDocumentFor2[0];
              err = _yield$getDocumentFor2[1];

              if (!err) {
                _context2.next = 13;
                break;
              }

              showApiError(err);
              return _context2.abrupt("return", true);

            case 13:
              url = URL.createObjectURL(new File([res], 'filename.json', {
                type: 'application/pdf'
              }));
              setPdf({
                url: url,
                isSign: false
              });
              return _context2.abrupt("return", false);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchDocument(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleSubmit = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _signManualRef$curren, _borrowerSignRef$curr, _employeeSignRef$curr, _guarantorSignRef$cur, _borrowerSignRef$curr2, _borrowerSignRef$curr3, _employeeSignRef$curr2, _employeeSignRef$curr3, _guarantorSignRef$cur2, _guarantorSignRef$cur3;

      var fileData, borrowerBase64, employeeBase64, guarantorBase64, formData, _yield$signDocumentFo, _yield$signDocumentFo2, res, err, url;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              fileData = (_signManualRef$curren = signManualRef.current) === null || _signManualRef$curren === void 0 ? void 0 : _signManualRef$curren.value;

              if (!((_borrowerSignRef$curr = borrowerSignRef.current) !== null && _borrowerSignRef$curr !== void 0 && _borrowerSignRef$curr.isEmpty() || (_employeeSignRef$curr = employeeSignRef.current) !== null && _employeeSignRef$curr !== void 0 && _employeeSignRef$curr.isEmpty() || (_guarantorSignRef$cur = guarantorSignRef.current) !== null && _guarantorSignRef$cur !== void 0 && _guarantorSignRef$cur.isEmpty() || _isNull(fileData))) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return", showError('Моля, подпишете документа!'));

            case 3:
              borrowerBase64 = (_borrowerSignRef$curr2 = borrowerSignRef.current) === null || _borrowerSignRef$curr2 === void 0 ? void 0 : (_borrowerSignRef$curr3 = _borrowerSignRef$curr2.getTrimmedCanvas()) === null || _borrowerSignRef$curr3 === void 0 ? void 0 : _borrowerSignRef$curr3.toDataURL();
              employeeBase64 = (_employeeSignRef$curr2 = employeeSignRef.current) === null || _employeeSignRef$curr2 === void 0 ? void 0 : (_employeeSignRef$curr3 = _employeeSignRef$curr2.getTrimmedCanvas()) === null || _employeeSignRef$curr3 === void 0 ? void 0 : _employeeSignRef$curr3.toDataURL();
              guarantorBase64 = (_guarantorSignRef$cur2 = guarantorSignRef.current) === null || _guarantorSignRef$cur2 === void 0 ? void 0 : (_guarantorSignRef$cur3 = _guarantorSignRef$cur2.getTrimmedCanvas()) === null || _guarantorSignRef$cur3 === void 0 ? void 0 : _guarantorSignRef$cur3.toDataURL();

              if (fileData) {
                formData = new FormData();
                formData.append('file', fileData);
              }

              _context3.next = 9;
              return signDocumentForCredit(creditId, fileData ? formData : _objectSpread(_objectSpread(_objectSpread({}, borrowerBase64 && {
                sign_image: borrowerBase64
              }), employeeBase64 && {
                employee_sign_image: employeeBase64
              }), guarantorBase64 && {
                guarantor_sign_image: guarantorBase64
              }), currentUnsigned);

            case 9:
              _yield$signDocumentFo = _context3.sent;
              _yield$signDocumentFo2 = _slicedToArray(_yield$signDocumentFo, 2);
              res = _yield$signDocumentFo2[0];
              err = _yield$signDocumentFo2[1];

              if (!err) {
                _context3.next = 15;
                break;
              }

              return _context3.abrupt("return", showApiError(err));

            case 15:
              url = URL.createObjectURL(new File([res], 'filename.json', {
                type: 'application/pdf'
              }));
              setPdf({
                url: url,
                isSign: true
              });

            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleSubmit() {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleNextSign = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var types, signBy, currentType, err, isPartnerWithSeparatePayment;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              types = _objectSpread({}, documentTypes);
              signBy = _objectSpread({}, types[currentUnsigned === null || currentUnsigned === void 0 ? void 0 : currentUnsigned.type]);
              Object.keys(signBy).forEach(function (v) {
                return signBy[v] = true;
              });
              types[currentUnsigned === null || currentUnsigned === void 0 ? void 0 : currentUnsigned.type] = signBy;
              currentType = unsignedType(types);

              if (!currentType) {
                _context4.next = 13;
                break;
              }

              _context4.next = 8;
              return fetchDocument(unsignedType(types));

            case 8:
              err = _context4.sent;

              if (!err) {
                _context4.next = 11;
                break;
              }

              return _context4.abrupt("return");

            case 11:
              _context4.next = 16;
              break;

            case 13:
              isPartnerWithSeparatePayment = (credit === null || credit === void 0 ? void 0 : credit.credit_payment_type) === CREDIT_PAYMENT_TYPE.home_visit_fee_separate_payment && isUserPartnerForCredit;
              if (!isPartnerWithSeparatePayment) _isFunction(onNext) && onNext();
              showSuccess('Всички документи са подписани успешно!');

            case 16:
              setDocumentTypes(types);

            case 17:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleNextSign() {
      return _ref5.apply(this, arguments);
    };
  }();

  var handleActivationFail = function handleActivationFail() {
    return _isFunction(onNext) && onNext();
  };

  var handleConfirmPaymentPlan = function handleConfirmPaymentPlan() {
    return setShowPaymentPlanPreview(true);
  }; // Show message for partner user when documents_after_approval need to be signed


  if (isUserPartnerForCredit && (credit === null || credit === void 0 ? void 0 : credit.status) === approved && (currentUnsigned === null || currentUnsigned === void 0 ? void 0 : currentUnsigned.type) === CREDITS_DOCUMENTS_TYPE.documents_after_approval) {
    return ___EmotionJSX(Paper, {
      header: "\u041F\u041E\u0414\u041F\u0418\u0421 \u041D\u0410 \u0414\u041E\u041A\u0423\u041C\u0415\u041D\u0422\u0418",
      margin: "2em 0"
    }, ___EmotionJSX("div", {
      css: infoCard
    }, ___EmotionJSX("div", {
      css: infoCardIcon
    }, ___EmotionJSX("i", {
      className: "las la-check-circle"
    })), ___EmotionJSX("div", {
      css: infoCardText
    }, ___EmotionJSX("h4", null, "\u041D\u044F\u043C\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438 \u0437\u0430 \u043F\u043E\u0434\u043F\u0438\u0441\u0432\u0430\u043D\u0435"), ___EmotionJSX("p", null, "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438\u0442\u0435 \u0437\u0430 \u0442\u043E\u0437\u0438 \u043A\u0440\u0435\u0434\u0438\u0442 \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0431\u044A\u0434\u0430\u0442 \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0438 \u043E\u0442 \u0441\u043B\u0443\u0436\u0438\u0442\u0435\u043B \u043D\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u043E\u0440\u0430."))), ___EmotionJSX(Row, {
      horizontalGap: 16,
      verticalGap: 8
    }, ___EmotionJSX(Col, {
      displayFlex: true,
      md: true,
      justify: "flex-end"
    }, ___EmotionJSX(Button, {
      type: "secondary",
      onClick: function onClick() {
        return history.push('/credits');
      }
    }, "\u0417\u0430\u0442\u0432\u043E\u0440\u0438"))));
  } // Show info message if user is not a partner but payment plan preview is required


  if (shouldShowPaymentPlanPreview && !isUserPartnerForCredit) {
    return ___EmotionJSX(Paper, {
      header: "\u041F\u041E\u0414\u041F\u0418\u0421 \u041D\u0410 \u0414\u041E\u041A\u0423\u041C\u0415\u041D\u0422\u0418",
      margin: "2em 0"
    }, ___EmotionJSX("div", {
      css: infoCard
    }, ___EmotionJSX("div", {
      css: infoCardIcon
    }, ___EmotionJSX("i", {
      className: "las la-user-clock"
    })), ___EmotionJSX("div", {
      css: infoCardText
    }, ___EmotionJSX("h4", null, "\u041E\u0447\u0430\u043A\u0432\u0430 \u0441\u0435 \u043F\u043E\u0434\u043F\u0438\u0441 \u043E\u0442 \u043F\u0430\u0440\u0442\u043D\u044C\u043E\u0440"), ___EmotionJSX("p", null, "\u0414\u043E\u0433\u043E\u0432\u043E\u0440\u044A\u0442 \u0437\u0430 \u0443\u0441\u043B\u0443\u0433\u0430 \u0434\u043E\u043C\u0430\u0448\u043D\u043E \u043F\u043E\u0441\u0435\u0449\u0435\u043D\u0438\u0435 \u0442\u0440\u044F\u0431\u0432\u0430 \u0434\u0430 \u0431\u044A\u0434\u0435 \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D \u043E\u0442 \u0441\u043B\u0443\u0436\u0438\u0442\u0435\u043B \u043D\u0430 \u043F\u0430\u0440\u0442\u043D\u044C\u043E\u0440\u0430, \u043E\u0431\u0441\u043B\u0443\u0436\u0432\u0430\u0449 \u0442\u043E\u0437\u0438 \u043A\u0440\u0435\u0434\u0438\u0442."), ___EmotionJSX("p", null, "\u0421\u043B\u0435\u0434 \u043F\u043E\u0434\u043F\u0438\u0441\u0432\u0430\u043D\u0435 \u043E\u0442 \u043F\u0430\u0440\u0442\u043D\u044C\u043E\u0440\u0430, \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438\u0442\u0435 \u0449\u0435 \u0431\u044A\u0434\u0430\u0442 \u0434\u043E\u0441\u0442\u044A\u043F\u043D\u0438 \u0437\u0430 \u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0430\u0442\u0430 \u0441\u0442\u044A\u043F\u043A\u0430."))), ___EmotionJSX(Row, {
      horizontalGap: 16,
      verticalGap: 8
    }, ___EmotionJSX(Col, {
      displayFlex: true,
      md: true,
      justify: "flex-end"
    }, ___EmotionJSX(Button, {
      type: "secondary",
      onClick: function onClick() {
        return history.push('/credits');
      }
    }, "\u0417\u0430\u0442\u0432\u043E\u0440\u0438"))));
  } // Show payment plan preview before signing (only for partners)


  if (shouldShowPaymentPlanPreview && isUserPartnerForCredit && !showPaymentPlanPreview) {
    return ___EmotionJSX(Paper, {
      header: "\u041F\u041E\u0413\u0410\u0421\u0418\u0422\u0415\u041B\u0415\u041D \u041F\u041B\u0410\u041D \u0417\u0410 \u0422\u0410\u041A\u0421\u0410 \u0414\u041E\u041C\u0410\u0428\u041D\u041E \u041F\u041E\u0421\u0415\u0429\u0415\u041D\u0418\u0415",
      margin: "2em 0"
    }, ___EmotionJSX(HomeVisitFeePaymentPlan, {
      paymentPlan: credit === null || credit === void 0 ? void 0 : credit.home_visit_fee_payment_plan
    }), ___EmotionJSX(Row, {
      horizontalGap: 16,
      verticalGap: 8,
      margin: "1em 0 0 0"
    }, ___EmotionJSX(Col, {
      displayFlex: true,
      md: true,
      justify: "flex-end"
    }, ___EmotionJSX(Button, {
      type: "secondary",
      onClick: function onClick() {
        return history.push('/credits');
      },
      margin: "0 1em 0 0"
    }, "\u0417\u0430\u0442\u0432\u043E\u0440\u0438"), ___EmotionJSX(Button, {
      onClick: handleConfirmPaymentPlan
    }, "\u041F\u0440\u043E\u0434\u044A\u043B\u0436\u0438"))));
  } // Show message for partner user when all documents are signed


  if (!currentUnsigned && (credit === null || credit === void 0 ? void 0 : credit.credit_payment_type) === CREDIT_PAYMENT_TYPE.home_visit_fee_separate_payment && isUserPartnerForCredit) {
    return ___EmotionJSX(Paper, {
      header: "\u041F\u041E\u0414\u041F\u0418\u0421 \u041D\u0410 \u0414\u041E\u041A\u0423\u041C\u0415\u041D\u0422\u0418",
      margin: "2em 0"
    }, ___EmotionJSX("div", {
      css: infoCard
    }, ___EmotionJSX("div", {
      css: infoCardIcon
    }, ___EmotionJSX("i", {
      className: "las la-info-circle"
    })), ___EmotionJSX("div", {
      css: infoCardText
    }, ___EmotionJSX("h4", null, "\u0412\u0441\u0438\u0447\u043A\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0438 \u0441\u0430 \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0438"), ___EmotionJSX("p", null, "\u0418\u0437\u043F\u043B\u0430\u0449\u0430\u043D\u0435\u0442\u043E \u043D\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u0430 \u043C\u043E\u0436\u0435 \u0434\u0430 \u0431\u044A\u0434\u0435 \u0438\u0437\u0432\u044A\u0440\u0448\u0435\u043D\u043E \u0441\u0430\u043C\u043E \u043E\u0442 \u0441\u043B\u0443\u0436\u0438\u0442\u0435\u043B \u043D\u0430 \u043A\u0440\u0435\u0434\u0438\u0442\u043E\u0440\u0430 \u0438\u043B\u0438 \u043A\u0440\u0435\u0434\u0438\u0442\u043D\u0438\u044F \u043F\u043E\u0441\u0440\u0435\u0434\u043D\u0438\u043A."))), ___EmotionJSX(Row, {
      horizontalGap: 16,
      verticalGap: 8
    }, ___EmotionJSX(Col, {
      displayFlex: true,
      md: true,
      justify: "flex-end"
    }, ___EmotionJSX(Button, {
      type: "secondary",
      onClick: function onClick() {
        return history.push('/credits');
      }
    }, "\u0417\u0430\u0442\u0432\u043E\u0440\u0438"))));
  }

  return ___EmotionJSX(Paper, {
    header: (_creditDocumentsTypeN = creditDocumentsTypeName[currentUnsigned === null || currentUnsigned === void 0 ? void 0 : currentUnsigned.type]) !== null && _creditDocumentsTypeN !== void 0 ? _creditDocumentsTypeN : 'ПОДПИС НА ДОКУМЕНТИ',
    margin: "2em 0"
  }, !activationFail && ___EmotionJSX("div", {
    css: pdfWrap
  }, ___EmotionJSX("iframe", {
    title: "\u0414\u043E\u0433\u043E\u0432\u043E\u0440",
    src: pdf === null || pdf === void 0 ? void 0 : pdf.url,
    width: "100%",
    height: "700px"
  })), !isSign && ___EmotionJSX(React.Fragment, null, (currentUnsigned === null || currentUnsigned === void 0 ? void 0 : (_currentUnsigned$docu = currentUnsigned.documents) === null || _currentUnsigned$docu === void 0 ? void 0 : _currentUnsigned$docu.signByBorrower) === false && ___EmotionJSX(React.Fragment, null, ___EmotionJSX("h5", {
    css: signLabel
  }, "\u041F\u043E\u0434\u043F\u0438\u0441 \u043D\u0430 ".concat(creditSignByTypeName[signByBorrower], ":")), ___EmotionJSX("div", {
    css: signWrap
  }, ___EmotionJSX(SignatureCanvas, {
    ref: borrowerSignRef,
    canvasProps: {
      className: 'sigCanvas'
    }
  }))), (currentUnsigned === null || currentUnsigned === void 0 ? void 0 : (_currentUnsigned$docu2 = currentUnsigned.documents) === null || _currentUnsigned$docu2 === void 0 ? void 0 : _currentUnsigned$docu2.signByEmployee) === false && ___EmotionJSX(React.Fragment, null, ___EmotionJSX("h5", {
    css: signLabel
  }, "\u041F\u043E\u0434\u043F\u0438\u0441 \u043D\u0430 ".concat(creditSignByTypeName[signByEmployee], ":")), ___EmotionJSX("div", {
    css: signWrap
  }, ___EmotionJSX(SignatureCanvas, {
    ref: employeeSignRef,
    canvasProps: {
      className: 'sigCanvas'
    }
  }))), (currentUnsigned === null || currentUnsigned === void 0 ? void 0 : (_currentUnsigned$docu3 = currentUnsigned.documents) === null || _currentUnsigned$docu3 === void 0 ? void 0 : _currentUnsigned$docu3.signByGuarantor) === false && ___EmotionJSX(React.Fragment, null, ___EmotionJSX("h5", {
    css: signLabel
  }, "\u041F\u043E\u0434\u043F\u0438\u0441 \u043D\u0430 ".concat(creditSignByTypeName[signByGuarantor], ":")), ___EmotionJSX("div", {
    css: signWrap
  }, ___EmotionJSX(SignatureCanvas, {
    ref: guarantorSignRef,
    canvasProps: {
      className: 'sigCanvas'
    }
  }))), (currentUnsigned === null || currentUnsigned === void 0 ? void 0 : (_currentUnsigned$docu4 = currentUnsigned.documents) === null || _currentUnsigned$docu4 === void 0 ? void 0 : _currentUnsigned$docu4.signManual) === false && ___EmotionJSX("div", {
    css: uploadSection
  }, ___EmotionJSX("h5", {
    css: uploadHeader
  }, ___EmotionJSX("i", {
    className: "las la-cloud-upload-alt"
  }), "\u041F\u0440\u0438\u043A\u0430\u0447\u0432\u0430\u043D\u0435 \u043D\u0430 \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442"), ___EmotionJSX("div", {
    css: uploadDropZone
  }, ___EmotionJSX("div", {
    css: uploadIcon
  }, ___EmotionJSX("i", {
    className: "las la-file-upload"
  })), ___EmotionJSX("p", {
    css: uploadMainText
  }, "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0441\u043A\u0430\u043D\u0438\u0440\u0430\u043D \u0438\u043B\u0438 \u0441\u043D\u0438\u043C\u0430\u043D \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442"), ___EmotionJSX(FileInput, {
    ref: signManualRef,
    fileFormat: true,
    accept: "image/*, application/pdf",
    formId: "file",
    label: "\u0418\u0437\u0431\u0435\u0440\u0438 \u0444\u0430\u0439\u043B",
    id: "file",
    required: true,
    max: 30
  }), ___EmotionJSX("p", {
    css: uploadSubText
  }, "JPG, PNG \u0438\u043B\u0438 PDF"), ___EmotionJSX("p", {
    css: uploadFileInfo
  }, "\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u0435\u043D \u0440\u0430\u0437\u043C\u0435\u0440: 30 MB")))), ___EmotionJSX(Row, {
    horizontalGap: 16,
    verticalGap: 8
  }, ___EmotionJSX(Col, {
    displayFlex: true,
    md: true,
    justify: "flex-end"
  }, ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Button, {
    type: "secondary",
    onClick: function onClick() {
      return history.push('/credits');
    },
    margin: "0 1em 0 0"
  }, "\u0417\u0430\u0442\u0432\u043E\u0440\u0438"), !isSign && ___EmotionJSX(Button, {
    type: activationFail ? 'success' : 'primary',
    onClick: activationFail ? handleActivationFail : handleSubmit
  }, activationFail ? 'Активирай' : 'Прикачи'), isSign && currentUnsigned && ___EmotionJSX(Button, {
    onClick: handleNextSign
  }, "\u041D\u0430\u043F\u0440\u0435\u0434")))));
};

SignDocument.propTypes = {
  creditId: PropTypes.number,
  creditStatus: PropTypes.string,
  credit: PropTypes.object,
  onNext: PropTypes.func,
  onNoDocuments: PropTypes.func,
  isAfterApproval: PropTypes.bool
};
export default SignDocument;